// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card-wrap[data-v-f87b420e] {\n  align-items: flex-start;\n}\n.params-item[data-v-f87b420e] {\n  padding-bottom: 0 !important;\n}\n.params-item > div[data-v-f87b420e] {\n    margin-right: 16px;\n    margin-bottom: 16px;\n}\n[data-v-f87b420e] .el-table thead th.el-table__cell {\n  background-color: #f4f6f9;\n}\n.textAline[data-v-f87b420e] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
